import React, { FormEvent, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";

import './styles.scss';

type ContactFormProps = {
  title?: string;
  cta?: string | null;
};

export function ContactForm({ title, cta }: ContactFormProps) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [question, setQuestion] = useState('');
  const [error, setError] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [recaptcha, setRecaptcha] = useState("")

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if(!recaptcha) {
      return;
    }
    try {
      setSubmitted(false);
      await fetch('https://nnri6tifkbko7mjei7lhqmg2wy0ftstf.lambda-url.us-east-1.on.aws/', {
        method: 'post',
        body: JSON.stringify({
          name,
          email,
          message: question,
          type: "contactUs"
        })
      }).then(response => {
        if (!response.ok) throw Error()
      });

      setName('');
      setEmail('');
      setQuestion('');
      setError(false);
      setSubmitted(true);
    } catch {
      setError(true);
    }
  }

  function onChange(value: string) {
    setRecaptcha(value);
  }

  return (
    <form onSubmit={handleSubmit} className='contact-form'>
      {title && <h2>{title}</h2>}
      <label>
        <span>Name</span>
        <input
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder='Write your name'
          required
        />
      </label>
      <label>
        <span>Email</span>
        <input
          value={email}
          onChange={e => setEmail(e.target.value)}
          type='email'
          placeholder='Write your e-mail'
          required
        />
      </label>
      <label>
        <span>Your question</span>
        <textarea
          value={question}
          onChange={e => setQuestion(e.target.value)}
          placeholder='Write your question'
          required
        />
      </label>
      <ReCAPTCHA sitekey="6Le9Fk4nAAAAAGH93Upf_XFVM7j9u6MOeJRMpk10" onChange={onChange}/>
      <button
        type='submit'
        className='primary-button-small'
      >
        {cta ? cta : 'Send message'}
      </button>
      {error && <p className='error'>There was an error sending your question. Try again later!</p>}
      {submitted && <p className='success'>Your question was successfully sent. Soon we will contact you!</p>}
    </form>
  );
}
